<div class="upload-container">
  <input type="file" [disabled]="disabled" (change)="onFileChange($event)" [attr.multiple]="multiple" [ariaLabel]="label" />
</div>
